var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "History") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DataGate-LP---Action-Buttons",
    transform: "translate(-602.000000, -428.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "History",
    transform: "translate(602.000000, 428.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.75,4.375 L15.75,4.375 L15.75,7 L1.75,7 L1.75,4.375 Z M8.75,15.75 C8.75,11.88425 11.88425,8.75 15.75,8.75 C16.3555,8.75 16.939125,8.834875 17.5,8.980125 L17.5,4.375 C17.5,3.41075 16.715125,2.625 15.75,2.625 L14,2.625 L14,0 L12.25,0 L12.25,2.625 L5.25,2.625 L5.25,0 L3.5,0 L3.5,2.625 L1.75,2.625 C0.784875,2.625 0,3.41075 0,4.375 L0,15.75 C0,16.715125 0.784875,17.5 1.75,17.5 L8.97925,17.5 C8.834875,16.939125 8.75,16.3555 8.75,15.75 L8.75,15.75 Z",
    id: "Fill-3065"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.375,16.6117875 L14.875,16.6117875 L14.875,12.2367875 L16.625,12.2367875 L16.625,14.8617875 L18.375,14.8617875 L18.375,16.6117875 Z M15.75,10.4867875 C12.854625,10.4867875 10.5,12.8422875 10.5,15.7367875 C10.5,18.6304125 12.854625,20.9867875 15.75,20.9867875 C18.645375,20.9867875 21,18.6304125 21,15.7367875 C21,12.8422875 18.645375,10.4867875 15.75,10.4867875 L15.75,10.4867875 Z",
    id: "Fill-3066"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.d542bb4276a3090640fe4a0e015ddc95.svg";
export { ForwardRef as ReactComponent };